// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { ReturnReason } from './return-reason';
import { Supplier } from './supplier';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ReturnPolicy extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** Boolean */
  allowRepair!: boolean;
  /** Boolean */
  allowReturn!: boolean;
  /** String */
  description!: string;
  /** Int32 */
  maxWaitForReturnDays?: number;
  /** String(60) */
  name!: string;
  /** String */
  policy!: string;
  /** Int32 */
  repairDays?: number;
  /** Int32 */
  returnDays?: number;
  /** Binary */
  rowVersion!: any;
  /** Guid FK supplier */
  supplierId!: string;
  /** Inv FK returnPolicyId */
  returnReasons!: ReturnReason[];
  /** FK supplierId */
  supplier!: Supplier;
}

